<header message="{{ 'REGISTRATION.NAVIGATION.HEADER' | translate:locale.language }}"></header>

<div id="occonRegistrationBody">
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row" style="display:flex">
      <div class="wizard">
        <div class="steps clearfix">
          <ul class="row">
            <li class="col-xs-3"
                [ngClass]="{'current': isStepActive(1), 'disabled': isStepActive(5) || isStepActive( 6) || isStepActive( 7) || !this.selectedMode}">
              <a
                (click)="isStepActive(5) || isStepActive( 6) || isStepActive( 7) || !this.selectedMode ? '' : stepChange.emit(1)"
                class="btn-white"><span>1</span> {{
                'REGISTRATION.NAVIGATION.ACCOUNT_TYPE' | translate:locale.language }}
                <fa-icon [icon]="checkMark" class="check-mark"
                         *ngIf="selectedMode"></fa-icon>
                <fa-icon [icon]="exclamationMark" class="exclamation-mark"
                         *ngIf="!selectedMode"></fa-icon>
              </a>
            </li>
            <li class="col-xs-3"
                [ngClass]="{'current': isStepActive(2), 'disabled': isStepActive(5) || isStepActive( 6) || isStepActive( 7) || !this.selectedMode}">
              <a
                (click)="isStepActive(5) || isStepActive( 6) || isStepActive( 7) || !this.selectedMode ? '' : stepChange.emit(2)"
                class="btn-white"><span>2</span> {{
                'REGISTRATION.NAVIGATION.ACCOUNT_INFO' | translate:locale.language }}
                <fa-icon [icon]="checkMark" class="check-mark"
                         *ngIf="registrationForm.get('company').valid
                                        && registrationForm.get('firstname').valid
                                        && registrationForm.get('lastname').valid
                                        && registrationForm.get('gender').valid
                                        && !registrationForm.get('remark').invalid
                                        && selectedMode"></fa-icon>
                <fa-icon [icon]="exclamationMark" class="exclamation-mark"
                         *ngIf="registrationForm.get('company').invalid
                                        || registrationForm.get('firstname').invalid
                                        || registrationForm.get('lastname').invalid
                                        || registrationForm.get('gender').invalid
                                        || registrationForm.get('remark').invalid
                                        || !selectedMode"></fa-icon>
              </a>
            </li>
            <li class="col-xs-3"
                [ngClass]="{'current': isStepActive(3), 'disabled': isStepActive(5) || isStepActive(6) || isStepActive( 7)|| !this.selectedMode}">
              <a
                (click)="isStepActive(5) || isStepActive( 3) || isStepActive( 7) || !this.selectedMode ? '' : stepChange.emit(3)"
                class="btn-white"><span>3</span> {{
                'REGISTRATION.NAVIGATION.PROFILE_INFO' | translate:locale.language }}
                <fa-icon class="check-mark" [icon]="checkMark" *ngIf="registrationForm.get('street').valid
                                        && registrationForm.get('zip').valid
                                        && registrationForm.get('city').valid
                                        && registrationForm.get('country').valid
                                        && registrationForm.get('one_of_two').valid
                                        && registrationForm.get('equal_email').valid
                                        && registrationForm.get('equal_email').get('email').valid
                                        && registrationForm.get('equal_email').get('confirm_email').valid"></fa-icon>
                <fa-icon class="exclamation-mark" [icon]="exclamationMark" *ngIf="registrationForm.get('street').invalid
                                        || registrationForm.get('zip').invalid
                                        || registrationForm.get('city').invalid
                                        || registrationForm.get('country').invalid
                                        || registrationForm.get('one_of_two').invalid
                                        || registrationForm.get('equal_email').invalid
                                        || registrationForm.get('equal_email').get('email').invalid
                                        || registrationForm.get('equal_email').get('confirm_email').invalid"></fa-icon>
              </a>
            </li>
            <li class="col-xs-3"
                [ngClass]="{'current': isStepActive(4), 'disabled': isStepActive(5) || isStepActive( 6) || isStepActive( 7) || !this.selectedMode}">
              <a
                (click)="isStepActive(5) || isStepActive( 6) || isStepActive( 7) || !this.selectedMode? '' : stepChange.emit(4)"
                class="btn-white"><span>4</span> {{
                'REGISTRATION.NAVIGATION.TERMS' | translate:locale.language }}
                <fa-icon [icon]="checkMark" class="check-mark" *ngIf="registrationForm.get('equal_password').get('password').valid
                                        && registrationForm.get('equal_password').get('confirm_password').valid
                                        && registrationForm.get('termsOfUse').valid
                                        && registrationForm.get('equal_password').valid"></fa-icon>
                <fa-icon [icon]="exclamationMark" class="exclamation-mark" *ngIf="registrationForm.get('equal_password').get('password').invalid
                                        && registrationForm.get('equal_password').get('confirm_password').invalid
                                        && registrationForm.get('termsOfUse').invalid
                                        && registrationForm.get('equal_password').invalid"></fa-icon>
              </a>
            </li>
          </ul>
        </div>
        <div class="wizard">
          <div class="content">
            <form name="signupForm" [formGroup]="registrationForm">
              <registration-wizard [(step)]="step"
                                   (stepChange)="saveCurrentStepToLocalStorage()"
                                   [registrationForm]="registrationForm"
                                   [registrationToken]="registrationToken"
                                   [selectedMode]="selectedMode">

                <!-- 1) Account Type -->
                <registration-wizard-step class="registrationPage">
                  <div class="registrationPageContainer" style="justify-content: center">
                    <div class="registrationItem header" style="justify-content: center">
                      <span><b>{{ 'REGISTRATION.ROLE_HEADER' | translate:locale.language }}</b></span>
                    </div>
                    <div class="registrationItem body" style="justify-content: center">
                      <div class="form-group" style="justify-content: center!important;">
                        <div id="registrationModeContainer">
                          <div  [ngClass]="{'selected': selectedMode === EUserType.CUSTOMER}"
                                class="registrationModeItem"
                                (click)="changeSelectedMode(EUserType.CUSTOMER, true)">
                            <div class="registrationModeHeader">
                              {{ 'REGISTRATION.CUSTOMER' | translate:locale.language }}
                            </div>
                            <div class="registrationModeDescription">
                              <span [innerHTML]="'REGISTRATION.ACCOUNT_TYPE.CUSTOMER_TEXT' | translate:locale.language"></span>
                            </div>
                          </div>
                          <div  class="registrationModeItem"
                                [ngClass]="{'selected': selectedMode === EUserType.CARRIER || selectedMode === EUserType.SUPPLIER}"
                                (click)="changeSelectedMode(EUserType.CARRIER, true)">
                            <div class="registrationModeHeader">
                              {{ 'REGISTRATION.SUPPLIER' | translate:locale.language }} / {{ 'REGISTRATION.CARRIER' | translate:locale.language }}
                            </div>
                            <div class="registrationModeDescription">
                              <span [innerHTML]="'REGISTRATION.ACCOUNT_TYPE.SUPPLIER_TEXT' | translate:locale.language"></span>
                            </div>
                          </div>
                          <input id="mode" name="mode" type="hidden" value=""/>
                        </div>
                      </div>
                    </div>
                  </div>
                </registration-wizard-step>

                <!-- 2) Account Information -->
                <registration-wizard-step class="registrationPage">
                  <div class="registrationPageContainer" style="justify-content: center">
                    <div class="registrationItem header">
                      <div></div>
                      <div style="min-width: 300px;">
                        <span><b>{{ 'REGISTRATION.COMPANY_HEADER' | translate:locale.language }}</b></span>
                      </div>
                    </div>
                    <div class="registrationItem body">
                      <div>
                        <fa-icon class="registrationIcon" icon="building" size="3x"></fa-icon>
                      </div>
                      <div>
                        <div class="form-group"
                              [ngClass]="{'has-error':!registrationForm.get('company').valid && registrationForm.get('company').touched}">
                          <ng-select [items]="selectableCompanies"
                                      appendTo="body"
                                      formControlName="company"
                                      [placeholder]="this.selectedMode ? ('REGISTRATION.COMPANY' | translate:locale.language) : ('REGISTRATION.COMPANY_PLACEHOLDER_NO_ROLE' | translate:locale.language)"
                                      [clearable]="false"
                                      [virtualScroll]="true">
                            <ng-template ng-label-tmp let-item="item">
                              <span>{{item}}</span>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <span [ngOptionHighlight]="search">{{item}}</span>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="registrationForm.get('company').hasError('required') && registrationForm.get('company').touched"
                            class="registrationpageAlert alert-danger">{{
                            'REGISTRATION.ERRORMESSAGE.COMPANY' | translate:locale.language }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="registrationItem header">
                      <div></div>
                      <div>
                        <span><b>{{ 'REGISTRATION.ACCOUNT_HEADER' | translate:locale.language }}</b></span>
                      </div>
                    </div>
                    <div class="registrationItem body">
                      <div>
                        <fa-icon icon="user" size="3x" class="registrationIcon"></fa-icon>
                      </div>
                      <div>
                        <div class="form-group"
                              [ngClass]="{'has-error':!registrationForm.get('firstname').valid && registrationForm.get('firstname').touched}">
                          <input id="firstname" name="firstname"
                                  class="form-control registrationInput"
                                  formControlName="firstname"
                                  placeholder="{{ 'REGISTRATION.FIRSTNAME' | translate:locale.language }}"
                                  title="{{ 'REGISTRATION.FIRSTNAME' | translate:locale.language }}"/>
                          <div
                            *ngIf="registrationForm.get('firstname').hasError('required') && registrationForm.get('firstname').touched"
                            class="registrationpageAlert alert-danger">{{
                            'REGISTRATION.ERRORMESSAGE.FIRSTNAME' | translate:locale.language }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="registrationItem body">
                      <div>
                      </div>
                      <div>
                        <div class="form-group"
                              [ngClass]="{'has-error':!registrationForm.get('lastname').valid && registrationForm.get('lastname').touched}">
                          <input id="lastname" name="lastname"
                                  class="form-control registrationInput"
                                  formControlName="lastname"
                                  placeholder="{{ 'REGISTRATION.LASTNAME' | translate:locale.language }}"
                                  title="{{ 'REGISTRATION.LASTNAME' | translate:locale.language }}"/>
                          <div
                            *ngIf="registrationForm.get('lastname').hasError('required') && registrationForm.get('lastname').touched"
                            class="registrationpageAlert alert-danger">{{
                            'REGISTRATION.ERRORMESSAGE.LASTNAME' | translate:locale.language }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="registrationItem body">
                      <div>
                      </div>
                      <div>
                        <div class="form-group"
                              [ngClass]="{'has-error':!registrationForm.get('gender').valid && registrationForm.get('gender').touched}">
                          <ng-select [items]="genderSelection"
                                      formControlName="gender"
                                      appendTo="body"
                                      placeholder="{{ 'REGISTRATION.GENDER' | translate:locale.language }}"
                                      bindValue="id"
                                      bindLabel="text"
                                      [clearable]="false"
                                      [searchable]="false">
                          </ng-select>
                          <div
                            *ngIf="registrationForm.get('gender').hasError('required') && registrationForm.get('gender').touched"
                            class="registrationpageAlert alert-danger">{{
                            'REGISTRATION.ERRORMESSAGE.GENDER' | translate:locale.language }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="registrationItem header"
                          [style.visibility]="(selectedMode === EUserType.CARRIER || selectedMode === EUserType.SUPPLIER) ? 'visible' : 'hidden'">
                      <div></div>
                      <div style="display: block; text-align: start;">
                        <div><b>{{ "REGISTRATION.REMARK_HEADER" | translate:locale.language }}</b></div>
                        <div style="font-size: 12px;">{{"REGISTRATION.REMARK_HINT_1" | translate:locale.language }}</div>
                        <div style="font-size: 12px;">{{"REGISTRATION.REMARK_HINT_2" | translate:locale.language }}</div>
                      </div>
                    </div>
                    <div class="registrationItem body"
                          [style.visibility]="(selectedMode === EUserType.CARRIER || selectedMode === EUserType.SUPPLIER) ? 'visible' : 'hidden'">
                      <div>
                        <fa-icon icon="comment-dots" class="registrationIcon" size="3x"></fa-icon>
                      </div>
                      <div>
                        <div class="form-group"
                              [ngClass]="{'has-error':!registrationForm.get('remark').valid && registrationForm.get('remark').touched}">
                          <input id="remark" name="remark"
                                  class="form-control registrationInput"
                                  formControlName="remark"
                                  placeholder="{{ 'REGISTRATION.REMARK' | translate:locale.language }}"
                                  title="{{ 'REGISTRATION.REMARK' | translate:locale.language }}"/>
                          <div
                            *ngIf="registrationForm.get('remark').hasError('required') && registrationForm.get('remark').touched"
                            class="registrationpageAlert alert-danger">{{
                            'REGISTRATION.ERRORMESSAGE.REMARK' | translate:locale.language }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </registration-wizard-step>

                <!-- 3) Profile Information -->
                <registration-wizard-step class="registrationPage">
                  <div class="registrationPageContainer">
                    <div class="registrationItem header">
                      <div></div>
                      <div>
                        <span><b>{{ 'REGISTRATION.ADDRESS_HEADER' | translate:locale.language }}</b></span>
                      </div>
                    </div>
                    <div class="registrationItem body">
                      <div>
                        <fa-icon icon="road" size="3x" class="registrationIcon"></fa-icon>
                      </div>
                      <div>
                        <div class="form-group"
                             [ngClass]="{'has-error':!registrationForm.get('street').valid && registrationForm.get('street').touched}">
                          <input id="street" name="street"
                                 class="form-control registrationInput"
                                 formControlName="street"
                                 placeholder="{{ 'REGISTRATION.STREET' | translate:locale.language }}"
                                 title="{{ 'REGISTRATION.STREET' | translate:locale.language }}"
                                 (change)="saveFormToLocalStorage()"/>
                          <div
                            *ngIf="registrationForm.get('street').hasError('required') && registrationForm.get('street').touched"
                            class="registrationpageAlert alert-danger">{{
                              'REGISTRATION.ERRORMESSAGE.STREET' | translate:locale.language
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="registrationItem body">
                      <div>
                        <fa-icon icon="map-marker-alt" class="registrationIcon" size="3x"></fa-icon>
                      </div>
                      <div>
                        <div class="form-group"
                             [ngClass]="{'has-error':!registrationForm.get('zip').valid && registrationForm.get('zip').touched}">
                          <input id="zip" name="zip"
                                 class="form-control registrationInput"
                                 formControlName="zip"
                                 placeholder="{{ 'REGISTRATION.ZIP' | translate:locale.language }}"
                                 title="{{ 'REGISTRATION.ZIP' | translate:locale.language }}"
                                 (change)="saveFormToLocalStorage()"/>
                          <div
                            *ngIf="registrationForm.get('zip').hasError('required') && registrationForm.get('zip').touched"
                            class="registrationpageAlert alert-danger">{{
                              'REGISTRATION.ERRORMESSAGE.ZIP' | translate:locale.language
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="registrationItem body">
                      <div>
                        <fa-icon icon="city" size="3x" class="registrationIcon"></fa-icon>
                      </div>
                      <div>
                        <div class="form-group"
                             [ngClass]="{'has-error':!registrationForm.get('city').valid && registrationForm.get('city').touched}">
                          <input id="city" name="city"
                                 class="form-control registrationInput"
                                 formControlName="city"
                                 placeholder="{{ 'REGISTRATION.CITY' | translate:locale.language }}"
                                 title="{{ 'REGISTRATION.CITY' | translate:locale.language }}"
                                 (change)="saveFormToLocalStorage()"/>
                          <div
                            *ngIf="registrationForm.get('city').hasError('required') && registrationForm.get('city').touched"
                            class="registrationpageAlert alert-danger">{{
                              'REGISTRATION.ERRORMESSAGE.CITY' | translate:locale.language
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="registrationItem body">
                      <div>
                        <fa-icon icon="globe" size="3x" class="registrationIcon"></fa-icon>
                      </div>
                      <div>
                        <div class="form-group"
                             [ngClass]="{'has-error':!registrationForm.get('country').valid && registrationForm.get('country').touched}">
                          <ng-select formControlName="country"
                                     [items]="allCountries"
                                     appendTo="body"
                                     placeholder="{{ 'REGISTRATION.COUNTRY_PLACEHOLDER' | translate:locale.language }}"
                                     bindLabel="name"
                                     bindValue="code"
                                     [clearable]="false"
                                     [virtualScroll]="true"
                                     (change)="saveFormToLocalStorage()">
                            <ng-template ng-label-tmp let-item="item">
                              <span>{{ item.name }}</span>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <span [ngOptionHighlight]="search">{{ item.name }}</span>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="registrationForm.get('country').hasError('required') && registrationForm.get('country').touched"
                            class="registrationpageAlert alert-danger">{{
                              'REGISTRATION.ERRORMESSAGE.COUNTRY' | translate:locale.language
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="registrationItem header">
                      <div></div>
                      <div>
                        <span><b>{{ 'REGISTRATION.CONTACT_HEADER' | translate:locale.language }}</b></span>
                      </div>
                    </div>
                    <div class="registrationItem body" formGroupName="one_of_two">
                      <div>
                        <fa-icon icon="phone-alt" size="3x" class="registrationIcon"></fa-icon>
                      </div>
                      <div>
                        <div class="form-group"
                             [ngClass]="{'has-error':!registrationForm.get('one_of_two').get('phone').valid && !registrationForm.get('one_of_two').get('mobile').valid && (registrationForm.get('one_of_two').get('phone').touched || registrationForm.get('one_of_two').get('mobile').touched)}">
                          <input id="phone" name="phone"
                                 class="form-control registrationInput phoneValidation"
                                 formControlName="phone"
                                 placeholder="{{ 'REGISTRATION.PHONE' | translate:locale.language }}"
                                 title="{{ 'REGISTRATION.PHONE' | translate:locale.language }}"
                                 (change)="saveFormToLocalStorage()"/>
                          <div
                            *ngIf="!registrationForm.get('one_of_two').valid && !registrationForm.get('one_of_two').get('phone').hasError('pattern') && !registrationForm.get('one_of_two').get('mobile').hasError('pattern') && (registrationForm.get('one_of_two').get('phone').touched || registrationForm.get('one_of_two').get('mobile').touched)"
                            class="registrationpageAlert alert-danger">{{
                              'REGISTRATION.ERRORMESSAGE.PHONE' | translate:locale.language
                            }}
                          </div>
                          <div
                            *ngIf="registrationForm.get('one_of_two').get('phone').hasError('pattern') && registrationForm.get('one_of_two').get('phone').touched"
                            class="registrationpageAlert alert-danger">{{
                              'REGISTRATION.ERRORMESSAGE.PHONE_PATTERN' | translate:locale.language
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="registrationItem body" formGroupName="one_of_two">
                      <div>
                      </div>
                      <div>
                        <div class="form-group"
                             [ngClass]="{'has-error':!registrationForm.get('one_of_two').get('phone').valid && !registrationForm.get('one_of_two').get('mobile').valid && (registrationForm.get('one_of_two').get('phone').touched || registrationForm.get('one_of_two').get('mobile').touched)}">
                          <input id="mobile" name="mobile"
                                 class="form-control registrationInput phoneValidation"
                                 formControlName="mobile"
                                 placeholder="{{ 'REGISTRATION.MOBILE' | translate:locale.language }}"
                                 title="{{ 'REGISTRATION.MOBILE' | translate:locale.language }}"
                                 (change)="saveFormToLocalStorage()"/>
                          <div
                            *ngIf="registrationForm.get('one_of_two').get('mobile').hasError('pattern') && registrationForm.get('one_of_two').get('mobile').touched"
                            class="registrationpageAlert alert-danger">{{
                              'REGISTRATION.ERRORMESSAGE.MOBILE_PATTERN' | translate:locale.language
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="registrationItem body" formGroupName="equal_email">
                      <div>
                        <fa-icon icon="envelope" size="3x" class="registrationIcon"></fa-icon>
                      </div>
                      <div>
                        <div class="form-group"
                             [ngClass]="{'has-error':(!registrationForm.get('equal_email').get('email').valid || !registrationForm.get('equal_email').get('confirm_email').valid) && ( registrationForm.get('equal_email').get('email').touched || registrationForm.get('equal_email').get('confirm_email').touched )}">
                          <input id="email" name="email"
                                 class="form-control registrationInput"
                                 formControlName="email"
                                 placeholder="{{ 'REGISTRATION.EMAIL' | translate:locale.language }}"
                                 title="{{ 'REGISTRATION.EMAIL' | translate:locale.language }}"
                                 (change)="saveFormToLocalStorage()"/>
                          <div
                            *ngIf="registrationForm.get('equal_email').get('email').hasError('required') && registrationForm.get('equal_email').get('email').touched"
                            class="registrationpageAlert alert-danger">{{
                              'REGISTRATION.ERRORMESSAGE.EMAIL' | translate:locale.language
                            }}
                          </div>
                          <div
                            *ngIf="registrationForm.get('equal_email').get('email').hasError('pattern') && !registrationForm.get('equal_email').get('email').hasError('required') && registrationForm.get('equal_email').get('email').touched"
                            class="registrationpageAlert alert-danger">{{
                              'REGISTRATION.ERRORMESSAGE.EMAIL_PATTERN' | translate:locale.language
                            }}
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="registrationItem body" formGroupName="equal_email">
                      <div>
                      </div>
                      <div>
                        <div class="form-group"
                             [ngClass]="{'has-error':(!registrationForm.get('equal_email').get('email').valid || !registrationForm.get('equal_email').get('confirm_email').valid) && ( registrationForm.get('equal_email').get('email').touched || registrationForm.get('equal_email').get('confirm_email').touched )}">
                          <input id="confirm_email" name="confirm_email"
                                 class="form-control registrationInput"
                                 formControlName="confirm_email"
                                 placeholder="{{ 'REGISTRATION.EMAIL_CONFIRM' | translate:locale.language }}"
                                 title="{{ 'REGISTRATION.EMAIL_CONFIRM' | translate:locale.language }}"
                                 (change)="saveFormToLocalStorage()"/>
                          <div
                            *ngIf="registrationForm.get('equal_email').get('confirm_email').hasError('required') && registrationForm.get('equal_email').get('confirm_email').touched"
                            class="registrationpageAlert alert-danger">{{
                              'REGISTRATION.ERRORMESSAGE.CONFIRM_EMAIL' | translate:locale.language
                            }}
                          </div>
                          <div
                            *ngIf="!registrationForm.get('equal_email').valid && registrationForm.get('equal_email').get('email').touched && registrationForm.get('equal_email').get('confirm_email').touched && registrationForm.get('equal_email').get('email').valid && registrationForm.get('equal_email').get('confirm_email').valid"
                            class="registrationpageAlert alert-danger">{{
                              'REGISTRATION.ERRORMESSAGE.EMAIL_EQUAL' | translate:locale.language
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </registration-wizard-step>

                <!-- 4) Security and Terms -->
                <registration-wizard-step class="registrationPage">
                  <div class="registrationPageContainer">
                    <div class="registrationItem header">
                      <div></div>
                      <div>
                        <span><b>{{ 'REGISTRATION.PASSWORD_HEADER' | translate:locale.language }}</b></span>
                      </div>
                    </div>
                    <div class="registrationItem body" formGroupName="equal_password">
                      <div>
                        <fa-icon icon="key" size="3x" class="registrationIcon"></fa-icon>
                      </div>

                      <div>
                        <div class="form-group"
                             [ngClass]="{'has-error':(!registrationForm.get('equal_password').get('password').valid || !registrationForm.get('equal_password').get('confirm_password').valid ) && (registrationForm.get('equal_password').get('password').touched || registrationForm.get('equal_password').get('confirm_password').touched)}">
                          <input id="password" name="password" type="password"
                                 class="form-control registrationInput"
                                 formControlName="password"
                                 placeholder="{{ 'REGISTRATION.PASSWORD' | translate:locale.language }}"
                                 title="{{ 'REGISTRATION.PASSWORD' | translate:locale.language }}"
                                 (change)="saveFormToLocalStorage()"/>
                          <div
                            *ngIf="registrationForm.get('equal_password').get('password').hasError('required') && registrationForm.get('equal_password').get('password').touched"
                            class="registrationpageAlert alert-danger">{{
                              'REGISTRATION.ERRORMESSAGE.PASSWORD' | translate:locale.language
                            }}
                          </div>
                          <div
                            *ngIf="registrationForm.get('equal_password').get('password').hasError('pattern') && registrationForm.get('equal_password').get('password').touched && !registrationForm.get('equal_password').get('password').hasError('required')"
                            class="registrationpageAlert alert-danger">{{
                              'REGISTRATION.ERRORMESSAGE.PASSWORD_WEAK'
                                | translate:locale.language
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="registrationItem body">
                      <div>
                      </div>
                      <div>
                        <password-strength-bar
                          [passwordToCheck]="registrationForm.get('equal_password').get('password').value">
                        </password-strength-bar>
                      </div>
                    </div>
                    <div class="registrationItem body" formGroupName="equal_password">
                      <div>
                      </div>
                      <div>
                        <div class="form-group"
                             [ngClass]="{'has-error':(!registrationForm.get('equal_password').get('password').valid || !registrationForm.get('equal_password').get('confirm_password').valid) && (registrationForm.get('equal_password').get('password').touched || registrationForm.get('equal_password').get('confirm_password').touched)}">
                          <input id="confirm_password" name="confirm_password"
                                 type="password" class="form-control registrationInput"
                                 formControlName="confirm_password"
                                 placeholder="{{ 'REGISTRATION.PASSWORD_CONFIRM' | translate:locale.language }}"
                                 title="{{ 'REGISTRATION.PASSWORD_CONFIRM' | translate:locale.language }}"
                                 (change)="saveFormToLocalStorage()"/>
                          <div
                            *ngIf="registrationForm.get('equal_password').get('confirm_password').hasError('required') && registrationForm.get('equal_password').get('confirm_password').touched && !registrationForm.get('equal_password').get('password').hasError('required')"
                            class="registrationpageAlert alert-danger">{{
                              'REGISTRATION.ERRORMESSAGE.CONFIRM_PASSWORD' |
                                translate:locale.language
                            }}
                          </div>
                          <div
                            *ngIf="!registrationForm.get('equal_password').valid && registrationForm.get('equal_password').get('password').touched && registrationForm.get('equal_password').get('confirm_password').touched && registrationForm.get('equal_password').get('password').valid"
                            class="registrationpageAlert alert-danger">{{
                              'REGISTRATION.ERRORMESSAGE.PASSWORD_EQUAL' | translate:locale.language
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="registrationItem body">
                      <div>
                        <fa-icon icon="file-signature" size="3x" class="registrationIcon"></fa-icon>
                      </div>
                      <div>
                        <div class="form-group"
                             [ngClass]="{'has-error':!registrationForm.get('termsOfUse').valid && registrationForm.get('termsOfUse').touched}">
                          <div>
                            <input id="termsOfUse" name="termsOfUse" type="checkbox"
                                   class="form-control registrationInput"
                                   formControlName="termsOfUse"
                                   (change)="saveFormToLocalStorage()"/>
                            <label style="width:unset"
                                   for="termsOfUse">{{ 'REGISTRATION.TERMS_OF_USE_1' | translate:locale.language }}
                              <a
                                (click)="showDisclaimer = true">{{ 'REGISTRATION.TERMS_OF_USE_2' | translate:locale.language }}</a></label>
                          </div>
                          <div
                            *ngIf="!registrationForm.get('termsOfUse').valid && registrationForm.get('termsOfUse').touched"
                            class="registrationpageAlert alert-danger"
                            [ngClass]="{'display' : !registrationForm.get('termsOfUse').valid && registrationForm.get('termsOfUse').touched}">{{ 'REGISTRATION.ERRORMESSAGE.TERMS_OF_USE' | translate:locale.language }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </registration-wizard-step>

                <registration-wizard-step class="registrationPage">
                  <div class="registrationPageContainer" style="justify-content: center">
                    <div class="registrationItem header">
                      <div></div>
                      <div style="flex: 0 1 60%">
                            <span
                              style="display: block; text-align:left"><b>{{ 'REGISTRATION.REGISTRATION_TOKEN_HEADER_1' | translate:locale.language }}
                              <i
                                class="color-occon-red-mid">{{ this.registrationForm.controls["equal_email"].value["email"] !== "" ? this.registrationForm.controls["equal_email"].value["email"].toLowerCase() : "placeholder@company.com" }}</i>{{ 'REGISTRATION.REGISTRATION_TOKEN_HEADER_2' | translate:locale.language }}
                              <br>{{ 'REGISTRATION.REGISTRATION_TOKEN_HEADER_3' | translate:locale.language }}</b></span>
                      </div>
                    </div>
                    <div class="registrationItem body">
                      <div>
                        <fa-icon icon="key" size="3x" class="registrationIcon"></fa-icon>
                      </div>
                      <div>
                        <div>
                          <input id="registrationToken" name="registrationToken" type="text"
                                 [(ngModel)]="this.registrationToken" [ngModelOptions]="{standalone: true}"
                                 class="registrationInput"
                                 placeholder="{{ 'REGISTRATION.REGISTRATION_TOKEN' | translate:locale.language }}"
                                 title="{{ 'REGISTRATION.REGISTRATION_TOKEN' | translate:locale.language }}"
                                 (change)="saveFormToLocalStorage()"/>
                          <div
                            *ngIf="!registrationTokenValid()"
                            class="registrationpageAlert alert-danger">{{
                              'REGISTRATION.ERRORMESSAGE.REGISTRATION_TOKEN' | translate:locale.language
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="registrationItem header">
                      <div></div>
                      <div style="flex: 0 1 60%">
                        <span><b><i>{{ 'REGISTRATION.REGISTRATION_TOKEN_HEADER_4' | translate:locale.language }}</i></b></span>
                      </div>
                    </div>
                  </div>
                </registration-wizard-step>

                <registration-wizard-step class="registrationPage">
                  <div class="registrationPageContainer last">
                    <div>
                      <fa-icon icon="exclamation-triangle" class="registration-failed-icon" size="10x"></fa-icon>
                    </div>
                    <span><strong>{{ 'REGISTRATION.FAILED_WRONG_TOKEN' | translate:locale.language }}</strong></span>
                  </div>
                </registration-wizard-step>

                <registration-wizard-step class="registrationPage">
                  <div class="registrationPageContainer last">
                    <div>
                      <fa-icon icon="check" class="registration-successful-icon" size="10x"></fa-icon>
                    </div>
                    <span><strong>{{ 'REGISTRATION.SUCCESS' | translate:locale.language }}</strong></span>
                  </div>
                </registration-wizard-step>

              </registration-wizard>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<footer></footer>

<p-dialog [(visible)]="showDisclaimer" styleClass="occon-modal occon-modal-lg portrait new-tender-modal"
          [resizable]="false" [modal]="true" [dismissableMask]="true" appendTo="body">
  <p-header>
    <span>{{ 'GENERAL.DISCLAIMER' | translate:locale.language }}</span>
  </p-header>
  <disclaimer></disclaimer>
  <p-footer>
    <button class="btn btn-success"
            (click)="showDisclaimer = false">{{ 'DATA.SHEETDESIGNER.LABELS.OK' | translate:locale.language }}
    </button>
  </p-footer>
</p-dialog>
